<template>
	<div>

		<div class="form_content2">
			<template v-for="(value, index) in fieldlist">
				<!-- group_id -->
				<div class="form_items Flexalign" v-if="value.is_show && value.group_id == types"
					:class="itemClass(value)">
					<!--  -->
					<template v-if="value.field_type === 1">
						<div class="tit">
							{{ value.field }}:
						</div>

						<el-input clearable :maxlength="value.maxLength" :disabled="value.disabled" show-word-limit
							v-model="value.content" >
						</el-input>
						<!--  -->
					</template>

					<template v-else-if="value.field_type === 2">
						<div class="tit">
							{{ value.field }}:
						</div>
						<!-- 多行 -->
						<el-input clearable :maxlength="value.maxLength" :disabled="value.disabled" show-word-limit
							type="textarea" :rows="2"  v-model="value.content">
						</el-input>
						<!--  -->
					</template>

					<template v-else-if="value.field_type === 3">
						<div class="tit">
							{{ value.field }}:
						</div>
						<!-- 时间 -->
						<el-date-picker v-model="value.content" :disabled="value.disabled" value-format="timestamp"
							type="date" placeholder="选择日期">
						</el-date-picker>
						<!--  -->
					</template>

					<template v-else-if="value.field_type === 4">
						<div class="tit">
							{{ value.field }}:
						</div>
						<!-- 数字 -->
						<el-input clearable :maxlength="value.maxLength" :disabled="value.disabled"
							v-model="value.content"  oninput="value=value.replace(/[^0-9.]/g,'')">
						</el-input>
						<!--  -->
					</template>


					<template v-else-if="value.field_type === 5">
						<div class="tit">
							{{ value.field }}:
						</div>
						<!-- 单选 -->
						<el-select v-model="value.content" :disabled="value.disabled">
							<el-option v-for="(item2, index2) in value.field_list" :key="item2.name" :label="item2.name"
								:value="item2.id">
							</el-option>
						</el-select>
						<!--  -->
					</template>


					<template v-else-if="value.field_type === 6">
						<div class="tit">
							{{ value.field }}:
						</div>
						<!-- 多选 -->
						<el-select multiple collapse-tags v-model="value.content" :disabled="value.disabled">
							<el-option v-for="(item2, index2) in value.field_list" :key="item2.name" :label="item2.name"
								:value="item2.id">
							</el-option>
						</el-select>
						<!--  -->
					</template>
					<template v-else-if="value.field_type === 7">
						<!-- 附件 -->
						<div class="tit" v-if="value.custom">
							{{ value.field }}:
						</div>
						<enclofile :ispowerDel="ispowerDel" :disabled="value.disabled" :enclist="value.content"
							:fieldid="value.id" @fndelet="fndelet" :filenum="value.field_list.fileNum"
							:filesize="value.field_list.fileSize" @setupfile="setupfile">
						</enclofile>
						<!--  -->
					</template>
					<!--  -->
					<template v-else-if="value.field_type === 8">
						<!--  -->
						<div class="tit">
							{{ value.field }}:
						</div>
						<!-- 图片 -->
						<enclofile :ispowerDel="ispowerDel" :disabled="value.disabled" :enclist="value.content"
							:fieldid="value.id" :filenum="value.field_list.imgNum" @fndelet="fndelet"
							@setupfile="setupfile" accept=".png,.jpg,.jpeg">
						</enclofile>
						<!--  -->
					</template>
					<!--  -->

					<template v-else-if="value.field_type === 9">
						<!-- 产品 -->
						<addproduct :ispowerEdit="ispowerEdit" :ispowerDel="ispowerDel" :islook="value.is_show"
							:isedit="!value.disabled" :isnodata="false" :show="show" :disabled="value.disabled"
							:pro_list="value.content" :fieldid="value.id" @eidht="headeidht" @deleteds="headdeleteds"
							@pushpro="headpushpro" @procomkl="headprocomkl"></addproduct>
						<!--  -->
					</template>


					<template v-else-if="value.field_type === 10">
						<div class="tit">
							{{ value.field }}:
						</div>
						<!-- 负责人 -->
						<el-select filterable v-model="value.content" placeholder="请选择" :disabled="value.disabled">
							<el-option v-for="(item2, index2) in member_list" :key="item2.name" :label="item2.name"
								:value="item2.member_id">
							</el-option>
						</el-select>
					</template>
					<!--  -->
					<template v-else-if="value.field_type === 11">
						<div class="tit">
							{{ value.field }}:
						</div>
						<!-- 协同人 -->
						<el-select v-model="value.content" filterable multiple collapse-tags clearable
							:disabled="value.disabled" placeholder="请选择">
							<el-option v-for="(item2, index2) in member_list" :key="item2.member_id" :label="item2.name"
								:value="item2.member_id">
							</el-option>
						</el-select>
					</template>

					<template v-else-if="value.field_type === 12">
						<div class="tit">
							{{ value.field }}:
						</div>
						<!-- 客户 -->
						<el-select v-model="value.content" filterable placeholder="请选择" :disabled="value.disabled"
							@change="changeCustomer">
							<el-option v-for="(item2, index2) in CustomerList" :key="item2.customer_id"
								:label="item2.customer_name" :value="item2.customer_id">
							</el-option>
						</el-select>
					</template>




					<!-- 联系人选择 -->
					<template v-else-if="value.field_type === 17">
						<div class="tit">
							{{ value.field }}:
						</div>
						<!--  -->

						<el-select :disabled="value.content ? false : contact_disabled" clearable
							v-model="value.content" filterable placeholder="请选择联系人">
							<el-option v-for="(item2, index2) in contactslist" :key="item2.contact_id"
								:label="item2.name" :value="item2.contact_id">
							</el-option>
						</el-select>
					</template>
					<!--  -->
				</div>

			</template>
		</div>


	</div>
</template>


<script>
	import addproduct from "components/content/addproduct/addproduct";
	import enclofile from "components/content/addproduct/enclofile";
	import {
		handlereq,
		alertMess,
		lxrl_list_contact,
		kh_customer_list,
	} from 'network/kh_public'
	import {

		getCustomerDetails,


	} from 'network/hk_customer'
	import {
		get_membelist,
	} from 'network/hk_operset'
	export default {
		components: {
			addproduct,
			enclofile,
		},
		props: {
			ispowerEdit: {
				type: Boolean,
				default: true,
			},
			ispowerDel: {
				type: Boolean,
				default: true,
			},
			types: {
				type: Number,
				default: 0,
			},
			// 是否获取全部客户 还是获取我负责的
			allCusts: {
				type: Boolean,
				default: false,
			},
			style2: {
				type: Boolean,
				default: false,
			},

			// 字段列表
			fieldlist: {
				type: Array,
				default: () => {
					return []
				},
			},
		},

		watch: {
			fieldlist() {
				// 是否有需要选择成员或者协同人的字段
				let flag1 = this.findTpye(10)
				let flag2 = this.findTpye(11)
				if (flag1 || flag2) {
					// 获取所有 成员 
					this.fn_getMembelist()
				}

				// 是否有需要选择客户的字段 
				let flag3 = this.findTpye(12)
				if (flag3) {
					this.fn_getCusList()
				}

				// 是否有需要选择联系人的字段 
				if (this.findTpye(17)) {
					let index_1 = this.fieldlist.findIndex(v => v.field_type == 12)
					// 如果当前客户字段已经选择了客户才能进行获取改客户下的联系人
					if (index_1 != -1 && this.fieldlist[index_1]) {
						let member_id = this.fieldlist[index_1].content
						if (typeof(member_id) == 'number') {
							this.get_contactslist(member_id)
						}
					}
				}
				// 
			},
		},
		methods: {
			itemClass(value) {
				return {
					'class2': value.field_type === 7 || value.field_type === 8 || value.field_type === 9 || value
						.field_type === 2,
					'required': value.required,
					'style2': this.style2,
				}
			},
			// 客户字段 选择一个客户后
			changeCustomer(customer_id) {
				if (customer_id) {
					this.fn_getDelait(customer_id)
					// let index2 = this.CustomerList.findIndex(v=>v.customer_id == customer_id)
					// if(index2 != -1 && this.CustomerList[index2]) {
					// 	console.log(this.CustomerList[index2],' this.CustomerList[index2]')
					// 	let customer_info = this.CustomerList[index2].customer_info

					// 	if (customer_info && typeof(customer_info) === 'string') {
					// 		let Json_Obj = JSON.parse(customer_info)
					// 		let address_ = ''
					// 		let index3 = Json_Obj.findIndex(v => v.field == '企业地址')
					// 		if (index3 != -1 && Json_Obj[index3]) {
					// 			address_ = Json_Obj[index3].content || '';

					// 			let index_4 = this.fieldlist.findIndex(v => v.field_sign == '客户收货地址')
					// 			if(index_4 != -1 && this.fieldlist[index_4]) {
					// 				this.fieldlist[index_4].content = address_
					// 			}
					// 		}

					// 	}
					// }
					// 选择客户后解锁联系人选择
					let flag1 = this.findTpye(17)
					if (flag1) { // 选择联系人
						let index_1 = this.fieldlist.findIndex(v => v.field_type == 17)
						// 找到联系人字段，清空联系人字段的值
						if (index_1 != -1 && this.fieldlist[index_1]) {
							this.fieldlist[index_1].content = ''
						}
						// 获取联系人列表
						this.get_contactslist(customer_id)
					}
				}
			},
			fn_getDelait(customer_id) {
				getCustomerDetails(customer_id).then(res => {
					if (handlereq(res)) {
						let obj = res.result
						//
						if (obj.customer_info && typeof(obj.customer_info) === 'string') {
							let info = JSON.parse(obj.customer_info)
							let index1 = info.findIndex(v => v.field == '企业地址')
							if (index1 != -1) {
								let address_ = info[index1].content || ''
								let index_4 = this.fieldlist.findIndex(v => v.field_sign == '客户收货地址')
								if (index_4 != -1 && this.fieldlist[index_4]) {
									this.fieldlist[index_4].content = address_
								}
							}
						}
						// 
					}
				})
			},
			// 根据字段类型查询字段是否存在
			findTpye(field_type) {
				return this.fieldlist.some(v => v.field_type == field_type)
			},

			// 获取所有 成员
			fn_getMembelist() {
				get_membelist().then(res => {
					if (handlereq(res)) {
						this.member_list = res.result.data || [];
					}
				})
			},

			// 获取联系人列表
			get_contactslist(customer_id) {
				let data = {
					sort_type: 1,
					pagesize: 999,
					page: 1,
					customer_id,
				}
				lxrl_list_contact(data).then(res => {
					if (handlereq(res)) {
						let list = res.result.data || []
						this.contactslist = list
						this.contact_disabled = false
					}
				})
			},



			// 获取客户列表
			fn_getCusList() {
				let data = {
					sort_type: 1, // 排序类型
					pagesize: 999, //  	
					page: 1,
					class_type: 1,
				}
				// if (this.allCusts) { // 获取 指定所属人 客户 我负责的
				// 	data.class_type = 1
				// }
				kh_customer_list(data).then(res => {
					if (handlereq(res)) {
						this.CustomerList = res.result.data || [];
					}
				})
			},

		},
		data() {
			return {
				dragshow: false,
				// 成员列表
				member_list: [],
				// 当前用户成员id
				member_id: '',
				member_name: '',
				// 联系人
				contactslist: [],
				// 联系人选择是否禁用
				contact_disabled: true,
				// 客户列表
				CustomerList: [],
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import "../../css/order.scss";
</style>